module.exports = __webpack_public_path__ + "img/Stofmasker_verplicht.8293cfd9.jpg";